import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { json, useLocation, useNavigate } from "react-router";
import { getReportType } from "../../redux/action";
import {
  PATINET_DOC_UPLOAD,
  SUBMIT_RELATIVE_INTAKE_FROM,
  UPLOAD_CLICNICAL_INTAKE_DOC,
  UPLOAD_CLICNICAL_INTAKE_FILE,
  UPLOAD_CLICNICAL_INTAKE_SUBMIT,
  VERIFY_RELATIVE_INTAKE_FROM,
} from "../../action/apiPath";
import { CallWithAuth, CallWithOutAuth } from "../../action/apiActions";
import mic from "../../assets/img/mic.png";
import upload_icon from "../../assets/img/upload_icoon.svg";
import smiley from "../../assets/img/smiley.svg";
import Modal from "react-bootstrap/Modal";

import { Button } from "react-bootstrap";
import { showToast, ToastContainer } from "../../util/toastHelper";
import {
  createShortNameFile,
  createShortNameFileDoc,
  errorMessageCreate,
  fileName,
  getFileType,
} from "../../util/custom";
import DigitalSignature from "../../components/digitalSignature";
import { base64ToFile } from "../../util/base64ToFile";
import ReactSignatureCanvas from "react-signature-canvas";
import "./signature.css"; // Import the CSS file for styling
import PatientHeader from "../../components/patient/PatientHeader";
import { PatientFooter } from "../../components/patient/PatientFooter";
import success from "../../assets/img/success.png";
import { Tooltip as ReactTooltip } from "react-tooltip";
import mutemic from  '../../assets/img/unmute-mic.svg';

const fieldConfig = {
  referral_info: {
    label: "Referral Information:",
    placeholder:
      "Who referred you, why, and when? (e.g., GP, self, diagnostic assessment)",
    key: "referral_info",
  },
  present_concern: {
    label: "Presenting Concerns:",
    placeholder:
      "What is the main concern and any additional concerns? Duration? How is this impacting daily life?",
    key: "present_concern",
  },
  medical_history: {
    label: "Medical and Psychiatric History:",
    placeholder:
      "Current diagnoses (medical and mental health), medications, allergies? Past conditions or surgeries?",
    key: "medical_history",
  },
  developmental_history: {
    label: "Developmental History:",
    placeholder:
      "Pregnancy/birth complications? Early developmental milestones?",
    key: "developmental_history",
  },
  family_history: {
    label: "Family and Social History:",
    placeholder:
      "Family mental and medical health history? Social support systems?",
    key: "family_history",
  },
  social_history: {
    label: "Educational/Occupational History:",
    placeholder:
      "Current education/occupation? Learning difficulties or accommodations?",
    key: "social_history",
  },
  substance_use_history: {
    label: "Substance Use History:",
    placeholder: "Any history of substance use or misuse?",
    key: "substance_use_history",
  },
  legal_history: {
    label: "Legal History:",
    placeholder: "Any involvement with legal issues or convictions?",
    key: "legal_history",
  },
  cultural_context: {
    label: "Cultural and Social Context:",
    placeholder: "Cultural background, religious beliefs, languages spoken?",
    key: "cultural_context",
  },
  phychosocial_trauma: {
    label: "Experience of Significant Psychosocial Trauma:",
    placeholder: "Details of any significant traumas and their impact?",
    key: "phychosocial_trauma",
  },
  additional_info: {
    label: "Additional Information:",
    placeholder: "Any other relevant factors for your assessment?",
    key: "additional_info",
  },
};

const categoryStatic = [
  {
    id: "6f1bf9f2-3f09-465b-9884-d657261687f5",
    name: "Report Type A",
    created_at: "2024-11-05T06:49:58.156Z",
    updated_at: "2024-11-05T06:49:58.156Z",
  },
  {
    id: "91081fbf-b1d2-4505-83e5-de95385588fd",
    name: "Report Type B",
    created_at: "2024-11-05T06:53:29.366Z",
    updated_at: "2024-11-05T06:53:29.366Z",
  },
  {
    id: "0433fd14-090c-4724-bc51-fcf35923819a",
    name: "Report Type C",
    created_at: "2024-11-05T06:53:33.298Z",
    updated_at: "2024-11-05T06:53:33.298Z",
  },
];

export default function RelaTiveIntakeFormNew() {
  const navigate = useNavigate();
  const [activeField, setActiveField] = useState(null);
  const [successfullSubmission, setSuccessfullSubmission] = useState(false);

  const [files, setFiles] = useState([
    { file: null, status: "not_uploaded", category: categoryStatic[0].id },
  ]);
  const [docs, setDocs] = useState([
    { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
  ]);

  const [dropdownOptions] = useState(categoryStatic);
  const [
    getDigitalSignatureFileBase64String,
    setDigitalSignatureFileBase64String,
  ] = useState(null);
  const location = useLocation();
  const [token, setToken] = useState(null);
  const [getFieldConfig, setFieldConfig] = useState(fieldConfig);
  const [dragging, setDragging] = useState(false);

  // for modal
  const [isVerified, setIsVerified] = useState(false);
  const [getotp, setOtp] = useState(null);
  const [patient_relevant_extra_info, setPatientRelevantExtraInfo] =
    useState("");
  const [mailToken, setMailToken] = useState("");
  const textareaRef = useRef(null);
  const signaturePadRef = useRef(null);
  const [patientName, setPatientName] = useState("");
  const [digitalSignature, setDigitalSignature] = useState("");
  const [isAddedSignature, setIsAddedSignature] = useState(null);
  const [patientRelativeName, setPatientRelativeName] = useState("");
  const [docsIds, setDocsIds] = useState("");
  const [patientConsent, setPatientConsent] = useState(false);
  const [patientDocs, setPatientdocs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDocsLoading, setIsDocsLoading] = useState(false);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);

  const [isVerifyOtp, setIsVerifyOtp] = useState(false);
  const [isFromSubmit, setIsFromSubmit] = useState(false);

  const [successfullSubmissionMessage, setSuccessfullSubmissionMessage] =
    useState("");
  const [patientData, setPatientData] = useState({
    referral_info: "",
    present_concern: "",
    medical_history: "",
    developmental_history: "",
    family_history: "",
    substance_use_history: "",
    legal_history: "",
    cultural_context: "",
    phychosocial_trauma: "",
    additional_info: "",
    collateral_transcription: "",
    face_image: "",
  });
   const [recognitionRef] = useState(() => {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      return new SpeechRecognition();
    });

  // console.log("============>", files, docs)
  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [patient_relevant_extra_info]);
  useEffect(() => {
    // Use URLSearchParams to get the token from the URL
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");
    const docsIdsParam = params.get("docs");

    // console.log("tokenParam", tokenParam);
    let hasVerified = localStorage.getItem("isVerified");
    let storageToken = localStorage.getItem("tokenParam");
    // console.log("hasVerified=====>", hasVerified);
    if (
      (hasVerified == "true" || hasVerified == true) &&
      hasVerified != null &&
      hasVerified != undefined &&
      hasVerified != "undefined" &&
      storageToken == tokenParam &&
      (localStorage.getItem("isFromSubmit") == "false" ||
        localStorage.getItem("isFromSubmit") == false)
    ) {
      // console.log("hasVerified=====>143", hasVerified);
      setIsVerified(true);
      setPatientName(localStorage.getItem("patientName"));
      setPatientRelativeName(localStorage.getItem("patientRelativeName"));
      if (
        localStorage.getItem("relativeConsent") == "true" ||
        localStorage.getItem("relativeConsent") == true
      ) {
        setPatientConsent(true);

        if (
          localStorage.getItem("patient_information") != undefined &&
          localStorage.getItem("patient_information") != "undefined"
        ) {
          const patientInformation = JSON.parse(
            localStorage.getItem("patient_information")
          );
          // console.log('patientInformation=====>',patientInformation);
          setPatientData({
            referral_info: patientInformation?.referral_info,
            present_concern: patientInformation?.present_concern,
            medical_history: patientInformation?.medical_history,
            developmental_history: patientInformation?.developmental_history,
            family_history: patientInformation?.family_history,
            substance_use_history: patientInformation?.substance_use_history,
            legal_history: patientInformation?.legal_history,
            cultural_context: patientInformation?.cultural_context,
            phychosocial_trauma: patientInformation?.phychosocial_trauma,
            additional_info: patientInformation?.additional_info,
            collateral_transcription:
              patientInformation?.collateral_transcription,
            face_image: patientInformation?.face_image,
          });
        }
        if (
          localStorage.getItem("docs") != undefined &&
          localStorage.getItem("docs") != "undefined"
        ) {
          setPatientdocs(JSON.parse(localStorage.getItem("docs")));
        }
      }
    } else {
      console.log(localStorage.getItem("isFromSubmit"));

      if (
        localStorage.getItem("isFromSubmit") == "true" ||
        localStorage.getItem("isFromSubmit") == true
      ) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("docs");
        localStorage.removeItem("isFromSubmit");
        localStorage.removeItem("isVerified");
        localStorage.removeItem("patientName");
        localStorage.removeItem("patientRelativeName");
        localStorage.removeItem("patient_information");
        localStorage.removeItem("tokenParam");
        showToast("error", "From already submitted");
        // navigate("/");
        setSuccessfullSubmissionMessage(
          "Contact intake From already submitted"
        );
        setSuccessfullSubmission(true);
      }
      if (
        docsIdsParam != "" ||
        docsIdsParam != null ||
        docsIdsParam != undefined
      ) {
        setDocsIds(docsIdsParam);
      }
      setIsVerified(false);
      localStorage.setItem("isVerified", false);
      localStorage.setItem("isFromSubmit", false);
    }
    // setIsVerified(false);

    if (tokenParam != undefined && tokenParam != null && tokenParam != "") {
      // console.log("tokenParam", tokenParam);
      setMailToken(tokenParam);
    } else {
      // navigate("/");
      setSuccessfullSubmissionMessage("Contact intake From already submitted");
      setSuccessfullSubmission(true);
    }
    setIsLoading(false);
  }, [location]);

  console.log("docsIds====>", patientDocs);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "110"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };
  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (patient_relevant_extra_info == "") {
      showToast("error", "Please add patient relevant extra info.");
      return;
    }
    if (digitalSignature == "") {
      showToast("error", "Please add digital signature.");
      return;
    }

    const allDocs = docs
      ?.filter((each) => each.status === "uploaded")
      ?.map((eachFile) => ({
        type: "doc",
        file: eachFile.doc,
        report_type_id: eachFile.category,
      }));
    const allFiles = files
      ?.filter((each) => each.status === "uploaded")
      ?.map((eachFile) => ({
        type: "audio",
        file: eachFile.file,
        report_type_id: eachFile.category,
        uploaded_by: "relative",
      }));

    const alldata = {
      signature: digitalSignature,
      patient_relevant_extra_info: patient_relevant_extra_info,
      files: [...allDocs, ...allFiles],
    };
    try {
      setIsFromSubmit(true);
      let response = await CallWithAuth(
        "POST",
        SUBMIT_RELATIVE_INTAKE_FROM,
        alldata
      );
      if (response?.res?.data?.statusCode === 200) {
        let message = errorMessageCreate(response?.res?.data?.message);
        showToast("success", message);
        setSuccessfullSubmission(true);
        localStorage.setItem("isFromSubmit", true);
        setSuccessfullSubmissionMessage(`Thank you for sharing information in the best interest of
                  ${patientName} care. You should receive a copy of the original
                  text (pdf format) of your submission via a secure email link
                  shortly. This pdf is a medical record and should be stored
                  compliantly with the relevant health legislation which governs
                  your professional role.`);
        setIsFromSubmit(false);
      } else {
        let message = errorMessageCreate(response?.res?.data?.message);
        showToast("error", message);
        setIsFromSubmit(false);
      }
    } catch (error) {
      console.log(error);
      setIsFromSubmit(false);
    }

    // console.log(alldata);
    // const response = await handleSubmitResponse(alldata);
    // setSuccessfullSubmission(true);
    // if (response?.res?.data?.statusCode === 200) {
    //   setSuccessfullSubmission(true);
    // }
    // Add form submission logic here
  };

  // Initialize Speech Recognition
  let isRecognizing = false;   

  useEffect(() => {   
      const recognition = recognitionRef;
      if (!activeField || activeField == null  ) { 
        return;
      };
      
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = 'en-US';
  
      recognition.onresult = (event) => {
        let finalTranscript = '';
  
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const result = event.results[i];
          if (result.isFinal) {
            finalTranscript += result[0].transcript;
          }
        }
  
        if (activeField && finalTranscript) {
          setPatientRelevantExtraInfo(prev => prev + " " + finalTranscript);
        }
      };
  
      recognition.onend = () => {
        if (activeField && isRecognizing) {        
          try {
            recognition.start();
            isRecognizing = true;
          } catch (e) {
            console.warn('Restart blocked:', e.message);
          }
        }
      };
  
      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
      };
  
      // Start recognition safely
      if (!isRecognizing) {
        try {
          recognition.start();
          isRecognizing = true;
        } catch (e) {
          console.warn('Initial start blocked:', e.message);
        }
      }
  
      return () => {
        recognition.stop();
        isRecognizing = false;
      };
    }, [activeField]);
  const handleVoiceInput = (field) => {
    const recognition = recognitionRef;
    if (activeField === field) {
      
      if (isRecognizing) {
              console.log("activeField", activeField,'isRecognizing',isRecognizing,'recognition',recognition);

        // recognition.stop();

        isRecognizing = false;
      }
      setActiveField(null);
    } else {
      if (isRecognizing) {
        // recognition.stop();
        
        isRecognizing = false;
      }
      setActiveField(field);
    }
    // const SpeechRecognition =
    //   window.SpeechRecognition || window.webkitSpeechRecognition;
    // const recognition = new SpeechRecognition();
    // recognition.continuous = false;
    // recognition.interimResults = false;
    // recognition.lang = "en-US";

    // recognition.onresult = (event) => {
    //   const transcript = event.results[0][0].transcript;
    //   // setFormData((prevData) => ({
    //   //   ...prevData,
    //   //   [field]: prevData[field] + " " + transcript,
    //   // }));
    //   if (field === "patient_relevant_extra_info") {
    //     setPatientRelevantExtraInfo(
    //       patient_relevant_extra_info + " " + transcript
    //     );
    //   }
    // };

    // recognition.onend = () => {
    //   setActiveField(null); // Reset active field when done
    // };
    // // console.log(field);

    // if (activeField === field) {
    //   recognition.stop();
    //   setActiveField(null);
    // } else {
    //   if (activeField !== null) {
    //     recognition.stop(); // Stop previous recognition if any
    //   }
    //   recognition.start();
    //   setActiveField(field);
    // }
  };

  const handleFileChange = (e, index) => {
    const newFiles = [...files];
    newFiles[index].file = e.target.files[0];
    newFiles[index].status = "not_uploaded";
    setFiles(newFiles);
  };

  const handleCategoryChange = (e, index) => {
    const newFiles = [...files];
    newFiles[index].category = e.target.value;
    setFiles(newFiles);
  };

  const handleUpload = async (index) => {
    const newFiles = [...files];
    const response = await handleUploadFile(newFiles[index].file);

    if (response?.res?.data?.statusCode === 200) {
      newFiles[index].status = "uploaded";
      newFiles[index].file = response?.res?.data?.data?.file_url;
    }
    setFiles(newFiles);
  };

  const addMoreFile = () => {
    setFiles([...files, { file: null, status: "not_uploaded", category: "" }]);
  };

  // Check if all files are uploaded
  const allFilesUploaded = files.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const handleDocsChange = (e, index) => {
    const newDocs = [...docs];
    if (!e.target.files[0]) {
      return;
    }
    // console.log("===========>", e.target.files)
    newDocs[index].doc = e.target.files[0];
    newDocs[index].system_file_name = e.target.files[0].name;
    newDocs[index].status = "not_uploaded";
    setDocs(newDocs);
  };

  const handleCategoryChangeForDocs = (e, index) => {
    const newDocs = [...docs];
    newDocs[index].category = e.target.value;
    setDocs(newDocs);
  };

  const handleUploadForDocs = async (index) => {
    const newDocs = [...docs];
    // setIsLoading(true);
    setIsDocsLoading(true);
    const response = await handleUploadDocFile(newDocs[index].doc);
    let message = errorMessageCreate(response?.res?.data?.message);

    if (response?.res?.data?.statusCode === 200) {
      newDocs[index].status = "uploaded";
      newDocs[index].doc = response?.res?.data?.data?.file_url;
      showToast("success", message);
    } else {
      let message = errorMessageCreate(response?.res?.data?.message);
      showToast("error", message);
    }
    // setIsLoading(false);
    setIsDocsLoading(false);
    setDocs(newDocs);
  };

  const addMoreFileForDocs = () => {
    if (docs.length === 6) {
      showToast("error", "You can upload maximum 6 documents");
      return;
    }
    setDocs([
      ...docs,
      { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
    ]);
  };
  const handleDeleteForDocs = (index) => {
    if (docs.length === 1) {
      setDocs([
        { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
      ]);
    } else {
      setDocs((prevDocs) => prevDocs.filter((_, i) => i !== index));
    }
  };
  const handleUploadDocFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", PATINET_DOC_UPLOAD, body);
    } catch (err) {}
  };

  const handleUploadFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_FILE, body);
    } catch (err) {}
  };

  const handleSubmitResponse = async (payload) => {
    try {
      return await CallWithAuth(
        "POST",
        UPLOAD_CLICNICAL_INTAKE_SUBMIT,
        payload
      );
    } catch (err) {}
  };
  //for speaker
  const handleVolumeUpDown = (value, key) => {
    // Create a copy of the fieldConfig state
    const updatedFieldConfig = { ...getFieldConfig };
    // Iterate over all keys in the updatedFieldConfig object
    Object.keys(updatedFieldConfig).forEach((k) => {
      // Set `isVolume` to false for all keys
      updatedFieldConfig[k].isVolume = false;
    });
    // Update the `isVolume` property for the specific key
    updatedFieldConfig[key] = {
      ...updatedFieldConfig[key],
      isVolume: true,
    };

    if ("speechSynthesis" in window) {
      const utterance = new SpeechSynthesisUtterance(value);
      if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel(); // Stop the current speech
      }
      window.speechSynthesis.speak(utterance);
    } else {
      alert("Speech Synthesis not supported in this browser.");
    }
    // Update the state with the modified fieldConfig
    setFieldConfig(updatedFieldConfig);
  };
  const handleVolumeUpDownReset = (value, key) => {
    // getFieldConfig[key].isVolume = false;
    // setFieldConfig(getFieldConfig);
    const updatedFieldConfig = { ...getFieldConfig };
    // Iterate over all keys in the updatedFieldConfig object
    Object.keys(updatedFieldConfig).forEach((k) => {
      // Set `isVolume` to false for all keys
      updatedFieldConfig[k].isVolume = false;
    });
    updatedFieldConfig[key] = {
      ...updatedFieldConfig[key],
      isVolume: false,
    };
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel(); // Stop the current speech
    }
    // Update the state with the modified fieldConfig
    setFieldConfig(updatedFieldConfig);
  };
  // console.log("311", getFieldConfig);

  // Handle file drop
  const handleDrop = (e, index) => {
    e.preventDefault();
    setDragging(false);

    // Get the dropped files
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      // Simulate onChange for the input file
      const event = {
        target: {
          name: `doc-${index}`,
          files,
        },
      };
      handleDocsChange(event, index);
    }
  };

  // Handle drag over to allow dropping
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  // Handle drag leave
  const handleDragLeave = () => {
    setDragging(false);
  };

  // Check if all files are uploaded
  const allFilesUploadedForDocs = docs.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const handleOtp = async () => {
    let isValid = true;
    if (!getotp || getotp == "" || getotp.trim() == "") {
      isValid = false;
    }

    // return ;
    if (isValid) {
      setIsVerifyOtp(true);
      try {
        const response = await CallWithOutAuth(
          "POST",
          `${VERIFY_RELATIVE_INTAKE_FROM}`,
          {
            otp: getotp,
            token: mailToken,
            // files:docsIds
            files: docsIds.replaceAll(" ", "+"),
          }
        );
        if (response?.res?.data?.statusCode === 200) {
          // console.log(response?.res?.data?.data?.patinet);

          localStorage.setItem("isVerified", true);
          localStorage.setItem("isFromSubmit", false);
          localStorage.setItem(
            "accessToken",
            response?.res?.data?.data?.auth_token
          );
          localStorage.setItem("tokenParam", mailToken);
          localStorage.setItem(
            "patientName",
            response?.res?.data?.data?.patient?.full_name
          );
          localStorage.setItem(
            "patientRelativeName",
            response?.res?.data?.data?.relative?.name
          );
          setIsVerified(true);
          showToast("success", response?.res?.data?.message);
          setPatientName(response?.res?.data?.data?.patient?.full_name);
          setPatientRelativeName(response?.res?.data?.data?.relative?.name);
          localStorage.setItem(
            "patient_information",
            JSON.stringify(response?.res?.data?.data?.patient)
          );

          let patientInformation = response?.res?.data?.data?.patient;
          if (patientInformation?.relative_consent) {
            localStorage.setItem("relativeConsent", true);
            localStorage.setItem(
              "docs",
              JSON.stringify(response?.res?.data?.data?.docs)
            );
            setPatientdocs(response?.res?.data?.data?.docs);
            setPatientData({
              referral_info: patientInformation?.referral_info,
              present_concern: patientInformation?.present_concern,
              medical_history: patientInformation?.medical_history,
              developmental_history: patientInformation?.developmental_history,
              family_history: patientInformation?.family_history,
              substance_use_history: patientInformation?.substance_use_history,
              legal_history: patientInformation?.legal_history,
              cultural_context: patientInformation?.cultural_context,
              phychosocial_trauma: patientInformation?.phychosocial_trauma,
              additional_info: patientInformation?.additional_info,
              collateral_transcription:
                patientInformation?.collateral_transcription,
              face_image: patientInformation?.face_image,
            });
            setPatientConsent(true);
          }
        } else {
          let message = errorMessageCreate(response?.res?.data?.message);
          showToast("error", message);
        }
        setIsVerifyOtp(false);
      } catch (err) {
        setIsVerifyOtp(false);

        console.log(err);
      }
    } else {
      showToast("error", "OTP fields is required.");
    }
  };

  const clearSignature = (e) => {
    e.preventDefault();
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
      setDigitalSignature("");
      setIsAddedSignature(false);
    }
  };

  const saveSignature = async (e) => {
    e.preventDefault();
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      setIsSignatureLoading(true);
      const signatureDataURL = signaturePadRef.current.toDataURL();
      // console.log("Saved Signature:", signatureDataURL);
      // Update the digital signature state with the new value
      // setDigitalSignatureFileBase64String(signatureData);
      let fileName = "digital_signature.jpeg";
      let signature_image = await base64ToFile(
        signatureDataURL,
        fileName,
        "image/jpeg"
      );
      const response = await handleUploadDocFile(signature_image);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        setDigitalSignature(response.res.data.data.file_url);
        showToast("success", "Digital signature uploaded successfully");
      } else {
        showToast("error", message);
      }
    } else {
      alert("Please provide a signature before saving.");
    }
    setIsSignatureLoading(false);
  };

  const handleSignatureChange = () => {
    // Check if the user has drawn a signature
    if (!signaturePadRef.current.isEmpty()) {
      setIsAddedSignature(true);
    }
  };
  return (
    <>
      <PatientHeader />

      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <div className="site_container mt-5 pt-5">
        <section className="clinical-intake-form">
          {successfullSubmission ? (
            <>
              {/* <img src={success} alt="success" className="successmsg" /> */}
              <div className="thankyou-box">
                <img src={smiley} alt="" />
                <h2>{successfullSubmissionMessage}</h2>
              </div>
            </>
          ) : (
            <>
              <div className="container">
                {isVerified ? (
                  <>
                    <h3>PsychScribe: Clinical Contact Intake Form </h3>
                    {patientConsent && (
                      <>
                        <h4>Patient All Details</h4>

                        <div className="row">
                          {patientData?.face_image && (
                            <>
                              <div
                                className="col-md-6"
                                style={{ display: "flex" }}
                              >
                                <p>
                                  {" "}
                                  <strong>Face Image:</strong>
                                </p>
                                {/* <a rel="noopener noreferrer" class="edit" href=`{}` target="_blank"><i class="fa-solid fa-eye"></i></a> */}
                                <a
                                  href={`${patientData.face_image}`} // Full URL for S3 file
                                  target="_blank" // Opens link in a new tab
                                  rel="noopener noreferrer" // Security best practice
                                  className="edit"
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </a>
                              </div>
                            </>
                          )}
                          {patientData?.referral_info && (
                            <div className="col-md-6">
                              <p>
                                <strong>Referral Info:</strong>{" "}
                                {patientData.referral_info}
                              </p>
                            </div>
                          )}

                          {patientData?.present_concern && (
                            <div className="col-md-6">
                              <p>
                                <strong>Present Concern:</strong>{" "}
                                {patientData.present_concern}
                              </p>
                            </div>
                          )}
                          {patientData?.medical_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Medical History:</strong>{" "}
                                {patientData.medical_history}
                              </p>
                            </div>
                          )}
                          {patientData?.developmental_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Developmental History:</strong>{" "}
                                {patientData.developmental_history}
                              </p>
                            </div>
                          )}
                          {patientData?.family_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Family History:</strong>{" "}
                                {patientData.family_history}
                              </p>
                            </div>
                          )}
                          {patientData?.social_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Social History:</strong>{" "}
                                {patientData.social_history}
                              </p>
                            </div>
                          )}
                          {patientData?.substance_use_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Substance Use History:</strong>{" "}
                                {patientData.substance_use_history}
                              </p>
                            </div>
                          )}
                          {patientData?.legal_history && (
                            <div className="col-md-6">
                              <p>
                                <strong>Legal History:</strong>{" "}
                                {patientData.legal_history}
                              </p>
                            </div>
                          )}
                          {patientData?.cultural_context && (
                            <div className="col-md-6">
                              <p>
                                <strong>Cultural Context:</strong>{" "}
                                {patientData.cultural_context}
                              </p>
                            </div>
                          )}
                          {patientData?.phychosocial_trauma && (
                            <div className="col-md-6">
                              <p>
                                <strong>Phychosocial Trauma:</strong>{" "}
                                {patientData.phychosocial_trauma}
                              </p>
                            </div>
                          )}
                          {patientData?.additional_info && (
                            <div className="col-md-6">
                              <p>
                                <strong>Additional Info:</strong>{" "}
                                {patientData.additional_info}
                              </p>
                            </div>
                          )}
                          {patientData?.collateral_transcription && (
                            <div className="col-md-6">
                              <p>
                                <strong>Collateral Transcription:</strong>{" "}
                                {patientData.collateral_transcription}
                              </p>
                            </div>
                          )}
                        </div>

                        {/* New Table */}
                        {patientDocs?.length > 0 && (
                          <>
                            <div className="table-wrapper">
                              <h2>Documents</h2>
                              <div className="table-responsive">
                                <table className="table table-bordered new-table">
                                  <thead>
                                    <tr>
                                      <th>File path</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {patientDocs?.map((doc) => (
                                      <tr key={doc.id}>
                                        <td>{fileName(doc.file)}</td>
                                        <td>
                                          <a
                                            href={`${doc.file}`} // Full URL for S3 file
                                            target="_blank" // Opens link in a new tab
                                            rel="noopener noreferrer" // Security best practice
                                            className="edit"
                                          >
                                            <i className="fa-solid fa-eye"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    ))}
                                    {patientDocs?.length == 0 && (
                                      <>
                                        <td
                                          colSpan={2}
                                          style={{ textAlign: "center" }}
                                        >
                                          No data Found
                                        </td>
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                    <div className="form-cntn-box">
                      <p>
                        <strong>{patientName}</strong> has provided their
                        written consent to obtain information from yourself to
                        assist with their upcoming diagnostic assessment and
                        report being completed by{" "}
                        <strong>{patientRelativeName}</strong>. Information is
                        protected under the 1988 Privacy Act and is securely
                        secured on our HIPPA and APP compliant platform
                        PsychScribe. You are not obliged to share information,
                        however if your decision is to not share information,
                        although not mandated, we advise in the interest of good
                        clinical practice, that you should communicate your
                        reasoning with <strong>{patientName}</strong>.
                      </p>
                      <h5>Important Note: </h5>
                      <p>
                        {/* <strong> */}
                        <h5>
                          When sharing information, please be aware that it will
                          be viewed by <strong> {patientName}</strong> in the
                          final report. Please ensure the information is
                          objective and accurate, free of bias and is shared
                          strictly for the purpose of a diagnostic assessment
                          and report. The information shared will undergo
                          editing by our Artificial Intelligence (AI) algorithms
                          prior to being transferred into{" "}
                          <strong> {patientName}</strong> report to assist with
                          formatting for <strong> {patientRelativeName}</strong>
                          , however the original text information and a summary
                          of supplied documents will be provided to both you and
                          <strong> {patientRelativeName}</strong> once you have
                          finalised submission.
                        </h5>
                        {/* </strong> */}
                      </p>{" "}
                      <p>
                        <h5>
                          Please also note PsychScribe Pty LTD is not legally
                          responsible for any inaccuracies between the original
                          text and the AI edited text in the report and it is
                          <strong> {patientRelativeName}</strong> responsibility
                          to cross reference the material, ensuring they review
                          any clinically inaccurate information prior to final
                          submission of the report.
                        </h5>
                      </p>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label htmlFor="">
                          Please provide any relevant information below that may
                          assist with the diagnostic assessment and report for
                          {" "}{patientName} below:{" "}
                          <sup className="text-danger">*</sup>
                        </label>
                        <textarea
                          ref={textareaRef}
                          className="form-control"
                          placeholder={`Please provide any relevant information below that may assist with the diagnostic assessment and report for ${patientName}xt`}
                          name="patient_relevant_extra_info"
                          value={patient_relevant_extra_info}
                          onChange={(e) =>
                            setPatientRelevantExtraInfo(e.target.value)
                          }
                        />
                        <button
                          type="button"
                          onClick={() =>
                            handleVoiceInput(`patient_relevant_extra_info`)
                          }
                          className="microphone"
                        >
                          {activeField == 'patient_relevant_extra_info' ? (
                              <img
                                src={mutemic}
                                alt="microphone"
                                width="24"
                                height="24"
                              />
                            ) : (
                            <img
                              src={mic}
                              alt="microphone"
                              width="24"
                              height="24"
                            />
                          )}
                        </button>
                      </div>

                      <div className="form-group col-info">
                        <label for="Collateral Information">
                          {/* Collateral Information */}
                          Please upload any relevant documents below that might
                          also assist with the diagnostic assessment and report
                          for {patientName}
                          {/* <sup className="text-danger">*</sup>. */}
                        </label>
                        <button
                         data-tooltip-id="my-tooltip-2"
                          type="button"
                          className="details-tooltips"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-custom-className="custom-tooltip"
                          data-bs-title="Please provide any collateral documents (e.g., school reports, medical records, psychological or allied health assessments) and upload relevant documentation below to assist with the assessment and report writing process)."
                        >
                          <i className="fa-solid fa-circle-info"></i>
                        </button>
                        <ReactTooltip
                            id="my-tooltip-2"
                            place="bottom"
                            variant="info"
                            className="custom-tooltip"
                            content="Please provide any collateral documents (e.g., school reports, medical records, psychological or allied health assessments) and upload relevant documentation below to assist with the assessment and report writing process)."
                          />
                      </div>

                      <div className="d-flex">
                        {/* **********************DOCUMENT UPLOAD****************** */}
                        <div className="w-50 pr-4 customclass">
                          {/* {JSON.stringify(docs)} */}
                          {docs.map((fileObj, index) => (
                            <div className="w-100">
                              <div key={index} className="form-group ff">
                                {fileObj.status === "uploaded" ? (
                                  // <span>
                                  //   <i
                                  //     className="fa-solid fa-file-alt"
                                  //     style={{ marginRight: "8px" }}
                                  //   ></i>
                                  //   Document File uploaded {createShortNameFile(fileObj.doc)}
                                  // </span>
                                  <>
                                    <div className="uploaded-file-info">
                                      <p>Document File uploaded</p>
                                      <p>
                                        <span
                                          className="file-name"
                                          data-tooltip-id={`collateral-Information-tooltip-${fileObj?.index}`}
                                          data-tooltip-content={fileObj.system_file_name}
                                        >
                                          {createShortNameFileDoc(fileObj.system_file_name)}
                                        </span>
                                        <ReactTooltip
                                          id={`collateral-Information-tooltip-${fileObj?.index}`}
                                          place="bottom"
                                          variant="info"
                                          className="custom-tooltip"
                                        />
                                        <span className="file-type">
                                          ({getFileType(fileObj.doc)})
                                        </span>
                                      </p>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      className="upload-container"
                                      onDrop={(e) => handleDrop(e, index)}
                                      onDragOver={handleDragOver}
                                      onDragLeave={handleDragLeave}
                                    >
                                      {/* <span className="upload-icon">
                                        <i className="fa-solid fa-arrow-up"></i>
                                      </span> */}

                                      <img  className="cursor_pointer_custom_cls" onClick={() => document.getElementById(`doc-input-${index}`).click()} src={upload_icon} alt="upload" />
                                      <input
                                        type="file"
                                        id={`doc-input-${index}`}
                                        name={`doc-${index}`}
                                        accept=".doc, .docx, .pdf , .png, .jpg, .jpeg"
                                        onChange={(e) =>
                                          handleDocsChange(e, index)
                                        }
                                      />
                                      <label
                                        htmlFor={`doc-input-${index}`}
                                        className="file-label cursor_pointer_custom_cls"
                                      >
                                        Upload
                                      </label>
                                      {fileObj.doc ? (
                                        <p
                                          id="file-name"
                                          className="browse-file"
                                        >
                                          Document Selected Please select
                                          Category and Upload doc.
                                        </p>
                                      ) : (
                                        <p
                                          id="file-name"
                                          className="browse-file"
                                        >
                                          Browse <span>to upload the file</span>
                                        </p>
                                      )}
                                    </div>
                                  </>
                                )}

                                <div className="otherbuttons d-flex">
                                  {/* <select
                                    value={fileObj.category}
                                    onChange={(e) =>
                                      handleCategoryChangeForDocs(e, index)
                                    }
                                    className="file-category-dropdown form-control"
                                  >
                                    {dropdownOptions.map((option, i) => (
                                      <option key={i} value={option.id}>
                                        {option.name}
                                      </option>
                                    ))}
                                  </select> */}

                                  <div className="d-flex">
                                    <button
                                      type="button"
                                      onClick={() => handleUploadForDocs(index)}
                                      className="upload-button form-control"
                                      disabled={
                                        isDocsLoading &&
                                        fileObj.status !== "uploaded"
                                          ? isDocsLoading
                                          : false
                                      }
                                    >
                                      {/* {fileObj.status === "uploaded"
                                        ? "Uploaded"
                                        : "Upload"} */}
                                      {isDocsLoading &&
                                      fileObj.status !== "uploaded" ? (
                                        <>
                                          Upload
                                          <span className="button-loader-cls"></span>
                                        </>
                                      ) : fileObj.status === "uploaded" ? (
                                        "Uploaded"
                                      ) : (
                                        "Upload"
                                      )}
                                    </button>
                                    {fileObj.status === "uploaded" && (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleDeleteForDocs(index)
                                        }
                                        className="delete-button form-control"
                                        style={{ marginLeft: "10px" }}
                                      >
                                        Remove
                                      </button>
                                    )}
                                  </div>

                                  {allFilesUploadedForDocs &&
                                    index === docs.length - 1 && (
                                      <button
                                        type="button"
                                        onClick={addMoreFileForDocs}
                                        className="add-more-button form-control"
                                      >
                                        Add More Files
                                      </button>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div style={{ marginTop: "20px" }}>
                        <p style={{ fontWeight: "bold" }}>
                          {/* Are you sure you want to provide a digital signature? */}
                          Please provide a digital signature{" "}
                          <sup className="text-danger">*</sup>.
                        </p>
                      </div>
                      {/* <>
                        <DigitalSignature
                          errorMessage="Please provide a signature before saving."
                          onSaveSignature={handleSaveSignature}
                          onClearCanvas={handleCanvasClear}
                        />
                      </> */}
                      <div className="signature-container">
                        <h3 style={{ borderBottom: "0" }}>Digital Signature</h3>
                        <ReactSignatureCanvas
                          ref={signaturePadRef}
                          penColor="black"
                          canvasProps={{
                            width: 550,
                            height: 200,
                            className: "signature-canvas",
                          }}
                          onEnd={handleSignatureChange}
                        />
                        <button className="clear-btn" onClick={clearSignature}>
                          {" "}
                          Clear signature
                        </button>
                        {isAddedSignature && (
                          <button
                            className="save-btn"
                            onClick={saveSignature}
                            disabled={isSignatureLoading}
                          >
                            Save signature{" "}
                            {isSignatureLoading && (
                              <>
                                <span className="button-loader-cls"></span>
                              </>
                            )}
                          </button>
                        )}
                      </div>

                      <div className="form-group">
                        <button type="submit" disabled={isFromSubmit || isSignatureLoading} className="btn btn-primary">
                          Submit {isFromSubmit && (
                            <>
                              {" "}
                              <span className="button-loader-cls"></span>{" "}
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    <Modal show={!isVerified}>
                      <Modal.Header>
                        <Modal.Title>Verify OTP</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Hi {`user`} ,<h5>Not Authorized to access this page</h5>
                        <p>
                          Please verify the one-time OTP you received in your
                          email to view the details.
                        </p>
                        <div className="row">
                          <div class="field_block col-md-12">
                            <label for="">
                              <strong>OTP</strong>{" "}
                              <sup className="text-danger">*</sup>
                            </label>
                            <input
                              type="text"
                              name="otp"
                              className="text_field form-control"
                              placeholder="Enter OTP"
                              onChange={(e) => setOtp(e.target.value)}
                              // value={patientDetail.full_name}
                              // onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="primary"
                          onClick={handleOtp}
                          type="button"
                        >
                          Verify OTP{" "}
                          {isVerifyOtp && (
                            <>
                              {""}
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </>
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                )}
              </div>
            </>
          )}
        </section>
      </div>
      <ToastContainer />
      <PatientFooter is_relative={true} />
    </>
  );
}
